<template>
    <div>
        <form class="form-horizontal auth-form my-4">
            <div class="form-group">
                <label for="userpassword">{{titles.newpassword}} </label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm fas fa-key"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.newPassword.password.$error }"
                            :placeholder=titles.enterNewPassword
                            class="form-control"
                            id="userpassword"
                            name="password"
                            type="password"
                            v-model="$v.newPassword.password.$model"
                    />
                    <div
                            class="invalid-feedback"
                            v-if="!$v.newPassword.password.required"
                    >
                        {{titles.fieldIsRequired}}
                    </div>
                    <div
                            class="invalid-feedback"
                            v-if="
              !$v.newPassword.password.mustBeValidPassword &&
                $v.newPassword.password.minLength
            "
                    >
                        {{titles.invalidPasswordMessage}}
                    </div>
                    <div
                            class="invalid-feedback"
                            v-if="!$v.newPassword.password.minLength"
                    >
                        {{titles.errorLengthName(6)}}
                    </div>
                </div>
            </div>
            <!--end form-group-->

            <div class="form-group">
                <label for="conf_password">{{titles.newRetypedPassword}}</label>
                <div class="input-group mb-3">
          <span class="auth-form-icon">
            <i class="icon-sm fas fa-key"></i>
          </span>
                    <input
                            :class="{ 'is-invalid': $v.newPassword.retypedPassword.$error }"
                            :placeholder=titles.enterConfirmNewPassword
                            class="form-control"
                            id="conf_password"
                            name="conf-password"
                            type="password"
                            v-model="$v.newPassword.retypedPassword.$model"
                    />
                    <div
                            class="invalid-feedback"
                            v-if="!$v.newPassword.retypedPassword.required"
                    >
                        {{titles.fieldIsRequired}}
                    </div>
                    <div
                            class="invalid-feedback"
                            v-if="!$v.newPassword.retypedPassword.sameAsPassword"
                    >
                        {{titles.passwordNotSame}}
                    </div>
                </div>
                <!--end form-group-->
            </div>
            <!--end form-group-->

            <div class="form-group mb-0 row">
                <div class="col-12 mt-2">
                    <button
                            :disabled="isLoading"
                            class="btn btn-standard-gradient btn-round btn-block waves-effect waves-light"
                            type="button"
                            v-on:click="submit"
                    >
                        <b-spinner small v-if="isLoading"></b-spinner>
                        {{titles.send}}
                    </button>
                </div>
                <!--end col-->
            </div>
        </form>
        <modal-success
                :title=titles.yourPasswordHasBeenChanged
                @messageFromModal="closeModal"
                id="success-password-changed"
        />
    </div>
</template>

<script>
    import {
        helpers,
        minLength,
        required,
        sameAs
    } from 'vuelidate/lib/validators';
    import {titles} from '../../../utils/general/titles.js';
    import ModalSuccess from '../../../components/common/modal-success';
    import {forgetPasswordChange} from '../../shared/services/user.service';

    const mustBeValidPassword = helpers.regex(
        'alpha',
        /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])/
    );
    export default {
        name: 'passwordForm',
        components: {ModalSuccess},
        data() {
            return {
                titles,
                errorMsg: '',
                isLoading: false,
                newPassword: {
                    password: '',
                    retypedPassword: ''
                }
            };
        },
        validations: {
            newPassword: {
                password: {
                    required,
                    mustBeValidPassword,
                    minLength: minLength(6)
                },
                retypedPassword: {
                    required,
                    sameAsPassword: sameAs('password')
                }
            }
        },
        props: {
            code: {
                type: String,
                required: true
            }
        },
        methods: {
            submit() {
                this.errorMsg = null;
                this.isLoading = true;
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                forgetPasswordChange(
                    this.newPassword.password,
                    this.newPassword.retypedPassword,
                    this.code
                )
                    .then(() => {
                        this.isLoading = false;
                        this.$bvModal.show('success-password-changed');
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.errorMsg = 'An unknown error occurred. Try again later.';
                    });
            },
            closeModal() {
                this.$router.push('/auth/login');
            }
        }
    };
</script>

<style scoped></style>
